export default {
  chat: {
    you_need_help: "Precisa de ajuda?",
    user_support: "Atendimento ao usuário",
    greeting: "Bem-vindo(a) ao atendimento ao usuário",
    select_option_to_continue: "Selecione uma opção abaixo para continuar",
    im_doubt: "Estou com dúvida",
    need_help: "Preciso de ajuda",
    doubt_message:
      "Caso esteja com dúvidas sobre a utilização do sistema, contamos com uma sessão de FAQ (Perguntas Frequentes)",
    access_faq: "Acessar FAQ",
    permissions: "Permissões",
    my_account: "Minha conta",
    permissions_error: "Problema com permissões",
    permissions_message:
      "O sistema exibe avisos caso você esteja tentando acessar uma página ou realizar alguma ação que não possui permissão.",
    error_permissions_message:
      "Caso esteja enfrentando outros problemas de permissão, você pode acessar o FAQ ou entrar em contato clicando no botão abaixo",
    contact: "Entrar em contato",
    password_reset: "Redefinição de senha",
    my_account_error: "Problema com a minha conta",
    my_account_message:
      "Caso esteja enfrentando problemas ao alterar sua senha, alternar entre unidades/perfis ou dados incorretos, entre em contato clicando no botão abaixo",
    problem_not_listed:
      "Caso o seu problema não esteja listado ou não tenha sido resolvido com o FAQ, entre em contato com nosso suporte clicando no botão abaixo",
    message:
      "O nosso suporte irá avaliar as informações enviadas e assim que possível você será notificado por e-mail.",
    feedback_error: "Erro ao enviar feedback.",
  },

  faq: {
    abbreviation: "FAQ",
    faq: "Perguntas Frequentes",
  },
};
